<template>
	<div class="page-in">
		<van-nav-bar :title="$t('商品详情')" fixed placeholder left-arrow z-index="99" @click-left="back" :border="false"
			v-if="isMobileFlag" />
		<div class="inside-page" >
			<div class="layui-container" v-if="goods">
				<div class="breadcrumb">
					<el-link type="info" @click="back">
						<span class="iconfont icon-l-left"></span><span>{{$t('返回')}}</span>
					</el-link>
				</div>
				<div class="detail-main">
					<div class="detail-swiper">
						<div class="bannerBox">
							<div class="swiper-container gallery_top">
								<div class="swiper-wrapper">
									<div class="swiper-slide" v-for="(item ,index) in goods.img" :key="`swiper${index}`">
										<img class="gallery_topimg1" :src="item" />
									</div>
								</div>
							</div>
							<div class="swiper-container gallery_thumbs">
								<div class="swiper-wrapper">
									<div class="swiper-slide swiper-bottom" v-for="(item ,index) in goods.img" :key="`swiper2${index}`">
										<div class="gallery_topimg_box">
											<img class="gallery_topimg" :src="item" />
										</div>
									</div>
								</div>
								<div class="swiper-button-prev">
								</div>
								<div class="swiper-button-next">
								</div>
							</div>
						</div>
					</div>
					<div class="detail-col">
						<form class="layui-form" action="">
							<div class="detail-head">
								<div class="flex-col">
									<div class="title">{{goods.title}}</div>
								</div>
								<span class="iconfont"
									:class="goods.is_collect?'icon-collect active':'icon-collect-solid'"
									@click.stop="toggleCollect(goods)"></span>
							</div>
							<div class="detail-intro">
								{{goods.introduction}}
							</div>
							<div class="detail-price">
								{{formatNumber(currentPrice)}} {{$t('VND')}}
							</div>
							<div class="sku-payment">
								{{goods.sell_count}}+{{$t('人付款')}}
							</div>
							<div class="sku-cell" v-for="(item, index) in spec_list" :key="item.id">
							  <div class="sku-label">{{ item.name }}：</div>
							  <div class="flex-col">
								<div class="layui-input-radios">
								  <el-radio-group v-model="detail.specValue[item.name]" @change="updateSpec">
									<el-radio
									  v-for="(attr, attrIndex) in item.items"
									  :key="attrIndex"
									  :label="attr"
									  border
									>
									  {{ attr }}
									</el-radio>
								  </el-radio-group>
								</div>
							  </div>
							</div>
							<template >
								<div class="sku-cell" v-if="attr_list && attr_list.length > 0" v-show="false">
								  <div class="sku-label">{{$t('规格')}}：</div>
								  <div class="flex-col">
									<div class="layui-input-radios">
									  <el-radio-group v-model="detail.spec" @change="updatePrice">
										<el-radio
										  v-for="(item, index) in attr_list"
										  :key="item.id"
										  :label="item.sku"
										  border
										>
										  {{ item.sku }}
										</el-radio>
									  </el-radio-group>
									</div>
								  </div>
								</div>
							</template>
							<div class="sku-number">
								{{$t('当前库存')}}：
								<span v-if="stock != ''">{{stock}}</span>
								<span v-else>{{goods.inventory}}</span>
								{{$t('件')}}
							</div>
							<div class="sku-cell sku-cell-number">
								<div class="sku-label">{{$t('人付款数量')}}：</div>
								<div class="flex-col">
									<div class="layui-input-number">
										<el-input-number v-model="detail.counter" :min="1" :max="999999"></el-input-number>
									</div>
								</div>
							</div>
							<div class="sku-button">
								<el-button-group>
									<el-button type="warning" :loading="loading" @click="addCart">
										{{$t('加入购物袋')}}
									</el-button>
									<el-button type="primary" @click="onSubmit">
										{{$t('立即结算')}}
									</el-button>
								</el-button-group>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<div class="detail-page detail-page-gray" v-if="goods">
			<div class="layui-container">
				<el-tabs v-model="activeName" class="el-skin-tabs" @tab-click="handleClick">
					<el-tab-pane :label="$t('商品参数')" name="first">
						<div class="goods-cell_row" v-if="goods.parameter && goods.parameter.length > 0">
							<div class="goods-cell_label">{{$t('商品参数')}}</div>
							<div class="goods-cell_col">
								<div class="detail-content">
									<div class="attr-panel">
										<el-row :gutter="20">
											<el-col :xs="24" :sm="12" :lg="8" v-for="(item,index) in goods.parameter"
												:key="index">
												<div class="attr-item_row">
													<div class="attr-label">{{$t(item.name)}}</div>
													<div class="flex-col">
														<div class="attr-value">{{$t(item.value)}}</div>
													</div>
												</div>
											</el-col>

										</el-row>
									</div>
								</div>
							</div>
						</div>
						<div class="goods-cell_row">
							<div class="goods-cell_label">
								{{$t('商品展示')}}
							</div>
							<div class="goods-cell_col">
								<div class="detail-content" v-html="goods.content">
								</div>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane :label="$t('商品评价')" name="second">
						<Comments :pid="this.$route.query.id"></Comments>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<div class="detail-page" v-if="allProducts">
			<Recommend :item="allProducts"> </Recommend>
		</div>
		
	</div>
</template>
<script>
	import Swiper from "swiper";
	import helper from '@/common/helper.js';
	import {
		user_set_favorites_api,
		index_goods_detail_api,
		index_goods_list_api
	} from "@/api/index"
	import {
		goods_addCart_api,
	} from "@/api/user"
	import Cooperation from '../Home/components/Cooperation.vue'
	import Recommend from '@/components/Recommend.vue'
	import Comments from '@/components/Comments.vue'
	export default {
		components: {
			Cooperation,
			Comments,
			Recommend
		},
		data() {
			return {
				galleryThumbs: {},
				detail: {
					specValue: {},
					counter: '',
					spec: '',
				},
				activeName: 'first',
				attr_list: null,
				goods: null,
				currentPrice: '',
				stock:'',
				spec_list: null,
				allProducts: null,
				loading: false,
				isEmptySpec:true
			};
		},
		methods: {
			updateSpec(){
				this.updateSelectedSku();
			},
			updateSelectedSku() {
			    const selectedSpecs = [];
			    this.spec_list.forEach(item => {
			        const selectedValue = this.detail.specValue[item.name]; // 获取用户选择的规格值
			        if (selectedValue) {
			            selectedSpecs.unshift(selectedValue); // 拼接 "规格名-规格值"
			        }
			    });
			    this.detail.spec = selectedSpecs.join('-');
				
				if (selectedSpecs.length === this.spec_list.length) {
					this.updatePrice();
					this.isEmptySpec = false
				}
			},
			updatePrice() {
			  // 根据选中的规格组合更新价格和库存
			  const selectedAttr = this.attr_list.find(attr => attr.sku === this.detail.spec);
			  if (selectedAttr) {
				this.currentPrice = selectedAttr.price;
				this.stock = selectedAttr.stock;
			  } else {
				this.currentPrice = '';
				this.stock = '';
			  }
			},
			// updatePrice() {
			//   const selectedItem = this.attr_list.find(item => item.sku === this.detail.spec);
			//   if (selectedItem) {
			// 	this.currentPrice = selectedItem.price; // 更新价格为规格价格
			// 	this.stock = selectedItem.stock
			//   }
			// },
			onSubmit() {
				
				if (this.isEmptySpec && this.spec_list.length > 0) {
					this.errorTips("请选择产品规格");
					return false;
				}
				
				
				let ConfirmProductData = helper.get('ConfirmProductData') || [];
				const newProduct = {
					goods_id: this.goods.id,
					title: this.goods.title,
					price: this.currentPrice,
					unit_price: this.currentPrice,
					sku: this.detail.spec,
					num: this.detail.counter,
					image: this.goods.img[0]
				};
				const productExists = ConfirmProductData.some(product => product.goods_id === newProduct.goods_id);
				// 更新缓存
				if (!productExists) {
					ConfirmProductData.push(newProduct);
				}
				helper.set('ConfirmProductData', ConfirmProductData);
				// 跳转到确认订单页面
				this.$router.push('/confirm-order');
			},
			handleClick(tab, event) {},
			async getGoodsData() {
				try {
					const res = await index_goods_list_api();
					if (res && res.data.code == 1) {
						this.allProducts = res.data.data.lists;
					}
				} catch (error) {
					console.error('获取商品数据失败', error);
				}
			},
			async getProductData() {
				let param = {
					id: this.$route.query.id
				}
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await index_goods_detail_api(param).then(res => {
					if (res && res.data.code == 1) {
						this.attr_list = res.data.data.attr_list,
							this.goods = res.data.data.goods,
							this.currentPrice = this.goods.price
							this.spec_list = res.data.data.spec_list,
							loading.close()
							this.$nextTick(function() {
								this.galleryThumbsLunbo();
								this.galleryTopLunbo();
							});
					}
				});
			},
			async addCart() {
				// if(!this.$store.state.isLoginStatu){
				// 	this.goUrl('/login')
				// 	return false
				// }
				if (this.isEmptySpec && this.spec_list.length > 0) {
					this.errorTips("请选择产品规格");
					return false;
				}
				this.$store.commit("$vuexSetAddCart", true);
				let param = {
					id: this.$route.query.id,
					num: this.detail.counter,
					sku: this.detail.spec,
				}
				if(!this.$store.state.isLoginStatu){
					param["uuid"] = helper.get('uuid') || ''
				}
				
				this.loading = true
				await goods_addCart_api(param).then(res => {
					if (res && res.data.code == 1) {
						this.$store.commit("$vuexSetAddCart", false);
						this.successTips('成功加入购物车');
						this.loading = false
						this.updateCart();
					} 
					else {
						this.errorTips(res.data.msg);
						this.loading = false
					}
				});
			},
			// 收藏
			async toggleCollect(product) {
				if(!this.$store.state.isLoginStatu){
					this.goUrl('/login')
					return false
				}
				let data = {
					id: product.id,
				};
				product.is_collect = !product.is_collect;
				if (product.is_collect) {
					this.successTips('收藏成功');
				} else {
					this.errorTips('取消收藏');
				}
				await user_set_favorites_api(data).then(res => {
					if (res && res.data.code == 1) {
						console.log(res.data.msg)
					}
				});
			},
			galleryTopLunbo() {
				new Swiper(".gallery_top", {
					spaceBetween: 0,
					loop: true,
					loopedSlides: 5,
					thumbs: {
						//thumbs组件专门用于制作带缩略图的swiper
						swiper: this.galleryThumbs,
						slideThumbActiveClass: "swiper-slide-thumb-active",
					},
				});
			},
			galleryThumbsLunbo() {
				this.galleryThumbs = new Swiper(".gallery_thumbs", {
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					spaceBetween: 12, //在slide之间设置距离（单位px）
					slidesPerView: 4, //设置slider容器能够同时显示的slides数量
					freeMode: true, //默认为false，普通模式：slide滑动时只滑动一格
					loopedSlides: 7, //一般设置大于可视slide个数2个即可
					watchSlidesVisibility: true, //开启watchSlidesVisibility选项前需要先开启watchSlidesProgress
					watchSlidesProgress: true, //开启这个参数来计算每个slide的progress(进度、进程)
				});
			},
			
		},
		created() {
			
		},
		mounted() {
			this.getProductData()
			this.getGoodsData()
			
		}
	}
</script>

<style scoped>
	.gallery_thumbs .swiper-button-next,
	.gallery_thumbs .swiper-button-prev {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 24px;
		height: 100%;
		cursor: pointer;
		background: #F2F2F2;
		color: #000;
		position: absolute;
		margin: 0;
		top: 0;
		z-index: 100;
	}
	.gallery_thumbs .swiper-button-prev{
		left: 0;
	}
	.gallery_thumbs .swiper-button-next{
		right: 0;
	}

	.gallery_topimg_name {
		position: absolute;
		bottom: 5px;
		left: 0;
		width: 100%;
		background: rgba(0, 0, 0, 0.2);
		font-size: 14px;
		font-weight: 400;
		color: #ffffff;
		line-height: 20px;
	}

	.gallery_topimg_box {
		position: relative;
		padding-top: 100%;
	}

	.gallery_topimg1 {
		width: 100%;
		height: 100%;
	}

	.gallery_topimg {
		width: 100%;
		height:  100%;
		position: absolute;
		top: 0;
		left: 0;
		cursor: pointer;
		border: 1px solid #ffffff;
	}
	.swiper-slide-thumb-active .gallery_topimg{
		border: 1px solid #000;
	}

	.bannerBox .gallery_top {
		width: 100%;
		height: 530px;
		margin-bottom: 15px;
	}

	.bannerBox .gallery_thumbs {
		width: 100%;
		padding: 0 30px;
		height: 110px;
	}

	.bannerBox .swiper-slide-thumb-active .gallery_topimg_box .gallery_topimg {
		opacity: 1;
	}

	.bannerBox .swiper-slide-thumb-active .gallery_topimg_box {
		background: #fff;
		opacity: 1;
	}

	.bannerBox {
		margin-bottom: 30px;
	}
	@media (max-width:992px) {
		.bannerBox .gallery_top{
			height: 375px;
		}
		.bannerBox .gallery_thumbs{
			height: 68px;
		}
	}
	
	
	
	
	
	
	
	
</style>